import { Modal } from "@/components/elements/Modal";
import { Stack, Typography } from "@mui/material";
import { FC, useEffect } from "react";
import { BlockerFunction, useBlocker, Location } from "react-router-dom";

type TConfirmLeavePageProps = {
  shouldBlock: boolean | BlockerFunction;
};

// Helper function to check if only query params changed
const isOnlyQueryParamsChanged = (currentLocation: Location, nextLocation: Location): boolean => {
  return currentLocation.pathname === nextLocation.pathname;
};

export const ConfirmLeavePage: FC<TConfirmLeavePageProps> = ({ shouldBlock }) => {
  // Wrap shouldBlock to skip blocking if only query params changed
  const modifiedShouldBlock: BlockerFunction = ({ currentLocation, nextLocation, historyAction }) => {
    if (isOnlyQueryParamsChanged(currentLocation, nextLocation)) return false;
    if (typeof shouldBlock === "function") {
      return shouldBlock({ currentLocation, nextLocation, historyAction });
    }
    return shouldBlock;
  };

  const blocker = useBlocker(modifiedShouldBlock);

  useEffect(() => {
    const beforeUnLoadHandler = (event: BeforeUnloadEvent) => {
      if (!shouldBlock) return;
      event.preventDefault();
      event.returnValue = "行った変更が保存されない可能性があります";
      return event;
    };
    window.addEventListener("beforeunload", beforeUnLoadHandler);
    return () => {
      window.removeEventListener("beforeunload", beforeUnLoadHandler);
    };
  }, [shouldBlock]);

  useEffect(() => {
    if (blocker.state === "blocked" && !shouldBlock) {
      blocker.proceed();
    }
  }, [shouldBlock, blocker]);

  if (blocker.state === "blocked" && shouldBlock) {
    return (
      <Modal isOpen onClose={blocker.reset} onOk={blocker.proceed} labelClose="いいえ" labelOk="はい" width={500}>
        <Stack mb={2}>
          <Typography>入力が終了しておりませんが戻ってもよろしいですか？</Typography>
        </Stack>
      </Modal>
    );
  }
  return null;
};
